import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from "@chakra-ui/react";
import { useState } from "react";

export type ConfirmModalProps = {
  title: string;
  mainText: string;
  isOpen: boolean;
  onClose: () => void;
  submit: () => Promise<void> | void;
};

// 汎用確認モーダル
export const ConfirmModal: React.FC<ConfirmModalProps> = ({
  title,
  mainText,
  isOpen,
  onClose,
  submit,
}) => {
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  const handleOk = async (): Promise<void> => {
    setIsSubmitting(true);
    await submit();
    setIsSubmitting(false);
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{title}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>{mainText}</ModalBody>
        <ModalFooter>
          <Button mr={3} colorScheme="blue" onClick={handleOk} isLoading={isSubmitting}>
            OK
          </Button>
          <Button onClick={onClose}>Cancel</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
